export default {
  LISTING: "listing page",
  LANDING: "landing page",
  HOME: "home page",
  VIDEO_DETAIL: "video detail page",
  PRINTABLE_DETAIL: "printable detail page",
  SHARE: "share",
  SEARCH: "search",
  DIRECT: "direct",
};
